import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import mixin from './components/mixin.js'
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import VueSimpleAlert from "vue-simple-alert";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';


const dict = {
  custom: {
    cantidad:{
      min_value: 'La cantidad no puede ser menor que 0'
    },
    precio:{
      min_value: 'El precio no puede ser menor que 0'
    },
    dto: {
      max_value: 'El descuento no puede ser mayor que 100',
      min_value: 'El descuento no puede ser menor que 0'
    }
  }
};
Validator.localize('en', dict);

Vue.use(VueAxios, axios)
Vue.use(VeeValidate);
Vue.use(VueSimpleAlert);
Vue.component("v-select", vSelect);

import lodash from 'lodash'
import VueLodash from 'vue-lodash'
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })


Vue.config.productionTip = false

//Vue.prototype.ApiBaseUrl = 'https://b2b.fiehisa.org:8095/FiehisaSlimVue/';
Vue.prototype.ApiBaseUrlNETCore = process.env.NODE_ENV === 'production' ? '/api/' : 'http://localhost:5204/';
//Vue.prototype.ApiBaseUrlNETCore = 'http://10.20.10.13:5000/';
Vue.prototype.PrintDocsFolder =  '/printdocs/';

//Vue.prototype.ApiBaseUrl = 'http://81.45.176.9:36005/QSMSlimDES/';
//Vue.prototype.ApiBaseUrlNETCore = 'http://81.45.176.9:36001/';

//Cargando asi el mixin queda como global y accesible desde toda la app
Vue.mixin(mixin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')